export default __webpack_public_path__ + "static/media/menuHero.278118cd.png";